module.exports = __webpack_public_path__ + "media/src/images/top_covers/2021_mar_04-0ee853f9f876c5651ebed3a0dac83c10.png";